import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";

const InfluencerCommunityEngagement = ({ brandId }) => {
    const { accessToken, role } = useAuth();
    const [influencerCommunityEngagement, setInfluencerCommunityEngagement] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];
    const fetchinfluencerCommunityEngagement = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/brand-InfluencerAndCommunityEngagement/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            setInfluencerCommunityEngagement(response.data);
        } catch (err) {
            console.error("Error fetching brand overview:", err);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (brandId) {
            fetchinfluencerCommunityEngagement();
        }
    }, [brandId, accessToken]);

    const handleEditClick = () => {
        setEditDialogVisible(true);
    };

    const handleinfluencerCommunityEngagementChange = (e) => {
        const { name, value } = e.target;
        setInfluencerCommunityEngagement((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        setSubmitLoading(true); // Start loading
        try {
            const response = await axios.put(
                `${config.apiBASEURL}/BrandBookRoutes/brand-InfluencerAndCommunityEngagement/${influencerCommunityEngagement.influencer_collaboration_id}/${brandId}`,
                influencerCommunityEngagement,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchinfluencerCommunityEngagement();
                }, 5000);
            }
        } catch (error) {
            console.error("Error updating brand overview:", error);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false); // Stop loading
        }
    };


    if (loading) return <p>Loading...</p>;
    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">

                    <div>
                        Influencer & Community Engagement
                        <small className="text-danger d-block mt-1" style={{ fontSize: '12px' }}>
                            Last Update: {influencerCommunityEngagement?.updatedAt ? new Date(influencerCommunityEngagement.updatedAt).toLocaleString('en-GB') : 'N/A'}
                        </small>
                    </div>
                    <div className="d-flex align-items-center">
                        <small className="text-warning ">
                            {allowedRoles.includes(role) && (
                                <Button
                                    title="Edit"
                                    icon="pi pi-pencil"
                                    className="p-0 border-0"
                                    text
                                    severity="help"
                                    onClick={handleEditClick}
                                />
                            )}
                        </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2 ">
                    <Table className="brandTable">
                        <tbody>
                            <tr>
                                <th className="text-start">Influencer Collaboration Guidelines:</th>
                                <td>
                                    {influencerCommunityEngagement?.influencerCollaborationGuidelines}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">UGC Strategy<small className="d-block">(User-Generated Content):</small></th>
                                <td>
                                    {influencerCommunityEngagement?.ugcStrategy}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Brand Ambassadors or Key Advocates</th>
                                <td>
                                    {influencerCommunityEngagement?.brandAmbassadors}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Engagement Strategy <small className="d-block">(Replying to comments, DMs, brand interactions):</small></th>
                                <td>
                                    {influencerCommunityEngagement?.engagementStrategy}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Response Time Expectations</th>
                                <td>
                                    {influencerCommunityEngagement?.responseTimeExpectations}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Edit Brand Overview"
                visible={editDialogVisible}
                style={{ width: '50vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row className="mx-0" style={{ height: '70vh', overflowY: 'auto' }}>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Influencer Collaboration Guidelines</Form.Label>
                        <Form.Control as="textarea" name="influencerCollaborationGuidelines" value={influencerCommunityEngagement.influencerCollaborationGuidelines} onChange={handleinfluencerCommunityEngagementChange} rows={3} className="h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>UGC Strategy <sub>(User-Generated Content)</sub></Form.Label>
                        <Form.Control as="textarea" name="ugcStrategy" value={influencerCommunityEngagement.ugcStrategy} onChange={handleinfluencerCommunityEngagementChange} rows={3} className="h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Brand Ambassadors or Key Advocates</Form.Label>
                        <Form.Control as="textarea" name="brandAmbassadors" value={influencerCommunityEngagement.brandAmbassadors} onChange={handleinfluencerCommunityEngagementChange} rows={3} className="h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Engagement Strategy <sub>(Replying to comments, DMs, brand interactions)</sub></Form.Label>
                        <Form.Control as="textarea" name="engagementStrategy" value={influencerCommunityEngagement.engagementStrategy} onChange={handleinfluencerCommunityEngagementChange} rows={5} className="h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Response Time Expectations</Form.Label>
                        <Form.Control as="textarea" name="responseTimeExpectations" value={influencerCommunityEngagement.responseTimeExpectations} onChange={handleinfluencerCommunityEngagementChange} rows={3} className="h-auto" />
                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default InfluencerCommunityEngagement
